const LanguagesEnum = [
    "es",
    "es_ar",
    "en",
];

export default LanguagesEnum;
